import { render, staticRenderFns } from "./EventSelectionRowMobile.vue?vue&type=template&id=2c6a8633"
import script from "./EventSelectionRowMobile.vue?vue&type=script&lang=js"
export * from "./EventSelectionRowMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports